import {useLocation, useNavigationType} from 'react-router-dom'
import {scrollTop} from '../shared/scroll-top'
import {updateNavbarAlphas} from './use-navbar-alphas'
import {effect} from '../shared/effect'

export function useScrollTopOnNavigate() {
    const location = useLocation()
    const type = useNavigationType()
    effect([location.key], () => {
        setTimeout(() => updateNavbarAlphas(), 27)
        if (type === 'POP') return
        if (location.pathname.includes('____l____e____x____e____r____')
            && window.previousPath?.includes('____l____e____x____e____r____')) {
            window.previousPath = location.pathname
            return
        }
        scrollTop(0)
        window.previousPath = location.pathname
    })
}
